import React from 'react';
import { AuthProvider } from './lib/auth';
import { StripeProvider } from './lib/billing';
import AppRouter from './components/AppRouter';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <StripeProvider>
        <AppRouter />
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;